export default {
  views: {
    product: {
      plans: {
        title: 'Select Plan'
      },
      cancelPolicy: {
        title: 'Cancel Policy'
      },
      recommendations: {
        title: 'Other Recommendations'
      },
      panels: {
        selectDate: 'Select Date',
        selectPlan: 'Select Plan',
        selectPeople: 'Select Number of People',
        options: 'Options',
        profile: 'Profile'
      },
      auth: {
        loginOrRegister: 'Login / Register'
      }
    },
    book: {
      title: 'Book Confirm',
      bookingNotice: 'Please check before booking',
      paymentConfirmation: 'Please check before payment',
      tip: 'To confirm your order, please complete the procedure within 15 minutes.',
      sessionInfo: 'Booking Information'
    },
    bookConfirm: {
      productInfo: 'Product Information',
      sessionConfirmed: 'Confirmed',
      sessionUnconfirmed: 'Not confirmed',
      paymentInfo: 'Payment Information',
      paymentConfirmation: {
        warningTitle: 'Please confirm the cancellation policy:',
        warningText: 'Once purchased, this product cannot be refunded.',
        agreementText: 'I have read and agree to the Terms and Conditions.'
      },
      prePaymentConfirmation: {
        title: 'Pre-payment Confirmation',
        checkInput: 'Please confirm that the entered information is correct.',
        emailNotice:
          'Note: If you have domain-specific email filtering enabled, please register "@linktivity.co.jp" before making a reservation.',
        agreementText: 'I have reviewed and agree to the above.'
      },
      paymentAmount: {
        total: 'Total Payment Amount (Including Tax)',
        details: 'Details',
        note: 'For non-JPY currencies, the displayed amount is an estimate based on the current exchange rate and may differ slightly from the actual charge. For reference only.'
      },
      confirmPaymentDialogTitle: 'Confirm payment',
      participantInfo: {
        title: 'Participant Information',
        dialogTitle: 'Edit Participant Information',
        change: 'Change',
        password: 'Password',
        validation: {
          passwordRequired: 'Please enter your password'
        }
      },
      couponApplied: 'Coupon applied successfully',
      couponFailed: 'Failed to apply coupon',
      couponRemoved: 'Coupon removed successfully',
      couponRemoveFailed: 'Failed to remove coupon',
      actionButtons: {
        back: 'Back',
        toPayment: 'To Payment'
      }
    },
    voucher: {
      pdf: 'Printable PDF',
      html: 'View Voucher'
    },
    bookingDetail: {
      title: 'Booking Details',
      detailInfo: 'Booking Details',
      startDate: 'Start Date',
      validityPeriod: 'Validity Period',
      voucherInfo: 'Voucher Information',
      digitalTicket: 'Digital Ticket',
      invoice: 'Receipt / Invoice',
      invoiceSend: 'Issue',
      invoiceSent: 'Invoice Issued',
      redemption: 'Use E-ticket',
      meetingPoint: 'Entry Location Guide',
      beforeTrip: 'Pre-use Checklist',
      bookingAction: 'Booking Actions',
      cancelBooking: 'Cancel Booking',
      cancelConfirmPolicy: 'Please confirm the cancellation policy:',
      customerName: 'Reservation Name',
      actualPayment: 'Payment Amount',
      refundAmount: 'Refund Amount',
      orderId: 'Booking ID',
      orderCompletionTime: 'Booking Time',
      digitalTicketValidPeriod: 'QR code is valid only on the day of use',
      digitalTicketWaiting:
        '*Digital ticket will be displayed here after order confirmation',
      sending: 'Sending...',
      sendToEmail: 'Send to Email',
      cancelConfirm: 'Are you sure you want to cancel the booking?',
      cancelFee: 'Cancellation Fee',
      cancelRemarkSelect: 'Please select a cancellation reason',
      inclusion: 'Included items',
      checklist: 'Checklist',
      restrictions: 'Restrictions',
      requirements: 'Requirements before and during participation',
      attireItems: 'Clothing and belongings required for participation',
      otherInfo: 'Other',
      attachmentType: {
        ATTACHMENT_TYPE_PDF: 'PDF',
        ATTACHMENT_TYPE_IMAGE: 'Image'
      }
    },
    cancelReason: {
      CANCEL_REASON_OTHER: 'Other',
      CANCEL_REASON_MODIFY_BOOKING: 'Modify booking',
      CANCEL_REASON_BOOKED_BY_MISTAKE: 'Booked by mistake',
      CANCEL_REASON_DUPLICATE_BOOKING: 'Duplicate booking',
      CANCEL_REASON_HEALTH_CONDITION: 'Illness',
      CANCEL_REASON_TRANSPORTATION_ISSUE: 'Transportation issue',
      CANCEL_REASON_SCHEDULE_CONFLICT: 'Schedule conflict',
      CANCEL_REASON_CHANGE_TO_OTHER_PRODUCT: 'Change to other product'
    },
    common: {
      withDashSeparated: '{{val1}} - {{val2}}'
    },
    home: {
      title: 'Triplabo',
      header: {
        alt: 'Triplabo'
      },
      search: {
        placeholder: 'Search products'
      },
      ticketList: {
        title: 'Ticket List'
      },
      enjoyPack: {
        title: 'Enjoy Pack'
      }
    }
  }
};
